import { Link } from '@tanstack/react-router';
import { Card, PageHeader, Stack } from '@sparkery/ui';

/**
 * Where a viewer lands when they reach a route they may not see.
 *
 * The shell stays mounted deliberately, so they can navigate somewhere they are
 * allowed rather than being dropped onto a dead end.
 */
export function ForbiddenView() {
  return (
    <>
      <PageHeader title="Not available" subtitle="You do not have access to that section" />
      <Card>
        <Stack gap="12px">
          <p className="typeBody">
            Your account does not include this section. If you think it should, ask an administrator
            on your team.
          </p>
          <div>
            {/* A real link, not a button that navigates — middle-click and
                open-in-new-tab should work on navigation. */}
            <Link to="/dashboard" className="btn btnPrimary">
              Back to dashboard
            </Link>
          </div>
        </Stack>
      </Card>
    </>
  );
}
